import { extend, localize } from 'vee-validate'

import {
  required,
  email,
  confirmed,
  min,
  alpha,
  numeric,
  max,
  // eslint-disable-next-line camelcase
  alpha_spaces,
} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
})
extend('alpha_spaces', {
  // eslint-disable-next-line camelcase
  ...alpha_spaces,
  message() {
    return 'Only letters'
  },
})
extend('numeric', {
  ...numeric,
})

extend('email', {
  ...email,
  message() {
    return 'Enter valid e-mail'
  },
})

extend('min', {
  ...min,
})

extend('confirmed', {
  ...confirmed,
})

extend('alpha', {
  ...alpha,
})

extend('max', {
  ...max,
})

extend('phones', {
  validate(value) {
    // Regex for a international phone number
    const MOBILEREG = /^[0-9.+()\-]+$/g
    return MOBILEREG.test(value)
  },
  message() {
    return 'The phone must be a valid'
  },
})
extend('number-calc', {
  validate(value) {
    // Regex for a international phone number
    const MOBILEREG = /^[0-9+\-]+$/g
    return MOBILEREG.test(value)
  },
  message() {
    return 'The number or . must be a valid.'
  },
})
extend('text', {
  validate(value) {
    const customRegex = /^[a-zA-Zа-яА-ЯЁёіІїЇ'ʼєЄґҐ ’]+$/g
    return customRegex.test(value)
  },
  message() {
    return 'Only letters'
  },
})
extend('one-lowercase', {
  validate(value) {
    const customRegex = new RegExp('(?=.*[a-z])')
    return customRegex.test(value)
  },
})
extend('one-uppercase', {
  validate(value) {
    const customRegex = new RegExp('(?=.*[A-Z])')
    return customRegex.test(value)
  },
})
extend('one-numeric', {
  validate(value) {
    const customRegex = new RegExp('(?=.*[0-9])')
    return customRegex.test(value)
  },
})

const locale = document.documentElement.lang

const dictionary = {
  messages: {
    required: 'This field is required',
    contactRequired: 'This field is required',
    email: 'Enter valid e-mail',
    decimal: 'Enter the correct number',
    numeric: 'Enter the correct number',
    alpha: 'Only letters',
    alpha_spaces: 'Only letters',
    min: (e, a) => ` Enter at least ${a.length} characters`,
    min_value: (e, a) => `Value can not be low then ${a.min}`,
    max: 'Value is too large',
    phones: 'The phone must be a valid1',
    confirmed: 'Field must be the same to new password',
    'one-lowercase': 'Field must contain at least 1 lowercase alphabetical character',
    'one-uppercase': 'Field must contain at least 1 uppercase alphabetical character',
    'one-numeric': 'Field must contain at least 1 numeric character',
  },
  // uk: {
  //   messages: {
  //     required: 'Поле обов`язкове до заповнення',
  //     email: 'Будь ласка введiть валiдний адрес пошти',
  //     decimal: 'Введiть коректне число',
  //     alpha: 'Тiльки лiтери',
  //     alpha_spaces: 'Тiльки лiтери',
  //     min: (e, a) => `Введiть мiнiмум ${a.length} символи `,
  //     min_value: (e, a) => `Введiть мiнiмум ${a.min} символи `,
  //     max: 'Введене значення задовге',
  //     phones: 'Поле телефону повинен бути дійсним телефоном',
  //   },
  // },
  // ru: {
  //   messages: {
  //     required: 'Обязательное поле',
  //     email: 'Введите валидный email',
  //     decimal: 'Введите корректное число',
  //     alpha: 'Только буквы',
  //     alpha_spaces: 'Только буквы',
  //     min: (e, a) => `Введите минимум ${a.length} символа `,
  //     max: 'Введенное значение превышает лимит',
  //     phones: 'Поле телефона должно быть действующим телефоном',
  //     confirmed: 'Поле должно совпадать с новым паролем',
  //     'one-lowercase': 'Поле должно содержать как минимум 1 строчный алфавитный символ',
  //     'one-uppercase': 'Поле должно содержать как минимум 1 заглавный алфавитный символ',
  //     'one-numeric': 'Поле должно содержать как минимум 1 числовой символ',
  //   },
  // },
  // de: {
  //   messages: {
  //     required: 'Dieses Feld ist erforderlich',
  //     email: 'Geben Sie eine gültige E-Mail-Adresse ein',
  //     decimal: 'Geben Sie die richtige Nummer ein',
  //     min_value: (e, a) => `Value can not be low then ${a.min} `,
  //     max_value: 'Geben Sie die richtige Nummer ein',
  //     alpha: 'Nur Buchstaben',
  //     phones: 'Das Telefonfeld muss ein gültiges Telefon sein',
  //   },
  // },
}
localize(dictionary)
localize(locale)



// WEBPACK FOOTER //
// ./src/js/components/validate/extends.js